export default __webpack_public_path__ + "static/media/flag-northern-mariana-islands.b341a970.svg";